module.exports = require(12).EventEmitter;
